import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { articles } from "../utils/articles";
import { filArianeJsonLd } from "../utils/donneesStructurees";
import { Calendar, Clock, ArrowRight } from "lucide-react";

const Blog = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        titre="Guides MaPrimeAdapt' et adaptation du logement"
        description="Nos guides pratiques sur MaPrimeAdapt' : démarches, montants, reste à charge, cumul des aides et travaux d'adaptation du logement."
        chemin="/blog"
        donnees={[
          filArianeJsonLd([
            { nom: "Accueil", url: "/" },
            { nom: "Guides", url: "/blog" },
          ]),
        ]}
      />
      <Header />

      <main id="contenu">

      <section className="bg-gradient-to-br from-orange-50 to-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Guides MaPrimeAdapt'
            </h1>
            <p className="text-xl text-gray-700">
              Les réponses détaillées aux questions que se posent les personnes qui
              adaptent leur logement : démarches, montants, reste à charge et cumul des aides.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto grid gap-8">
            {articles.map((a) => (
              <article
                key={a.slug}
                className="border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow"
              >
                <div className="flex flex-wrap items-center gap-4 text-sm text-gray-700 mb-3">
                  <span className="inline-flex items-center">
                    <Calendar className="h-4 w-4 mr-1" aria-hidden="true" />
                    <time dateTime={a.date}>
                      {new Date(a.date).toLocaleDateString("fr-FR", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </time>
                  </span>
                  <span className="inline-flex items-center">
                    <Clock className="h-4 w-4 mr-1" aria-hidden="true" />
                    {a.lecture}
                  </span>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mb-3">
                  <Link to={`/blog/${a.slug}`} className="hover:text-orange-700 transition-colors">
                    {a.titre}
                  </Link>
                </h2>

                <p className="text-gray-700 leading-relaxed mb-4">{a.resume}</p>

                <Link
                  to={`/blog/${a.slug}`}
                  className="inline-flex items-center min-h-[44px] text-orange-700 font-medium hover:text-orange-800"
                >
                  Lire le guide
                  <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      </main>

      <Footer />
    </div>
  );
};

export default Blog;
